import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '@app/api/api-services/crud.service';
import { MentoringConversationApiModel } from '@app/api/api-models/program/mentoring/MentoringConversationApiModel';
import { MentoringConversationListApiModel } from '@app/api/api-models/program/mentoring/MentoringConversationListApiModel';

@Injectable()
export class MtConversationsService extends CrudService<MentoringConversationListApiModel, string> {
  public apiUrl = 'mentoring-conversations';

  public getConversationsList(programRoleId: string): Observable<MentoringConversationListApiModel[]> {
    return this.http.get<MentoringConversationListApiModel[]>(`${this.apiUrl}/get-list/${programRoleId}`);
  }

  public addConversation(model: MentoringConversationApiModel): Observable<MentoringConversationApiModel> {
    return this.http.post<MentoringConversationApiModel>(`${this.apiUrl}/add`, model);
  }

  public updateConversation(model: MentoringConversationApiModel): Observable<MentoringConversationApiModel> {
    return this.http.put<MentoringConversationApiModel>(`${this.apiUrl}/update`, model);
  }
}
